import { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUserContext, useModal } from '../../contexts';
import { ProtectedRouteProps } from './ProtectedRoute.types';

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { user } = useUserContext();
    const { auth } = useModal();
    const navigate = useNavigate();
    const hasShownModal = useRef(false);

    const navigateToHomePage = useCallback(() => {
        navigate('/');
    }, [navigate]);

    useEffect(() => {
        // Только на клиенте, для неавторизованных пользователей и если модальное окно еще не показывалось
        if (!user.isAuth && !hasShownModal.current) {
            // Открываем модальное окно
            auth.open({ onClose: navigateToHomePage });

            // Помечаем, что модальное окно уже показывалось
            hasShownModal.current = true;
        }
    }, [user.isAuth, auth, navigateToHomePage]);

    // Всегда рендерим страницу - модальное окно покажется поверх контента
    return <>{children}</>;
};
